import dynamic from 'next/dynamic';
import { FC } from 'react';
import cn from 'classnames';

const Skeleton = dynamic(() => import('react-loading-skeleton'), {
  ssr: false
});

interface Props {
  loaderList: {
    className?: string;
    containerClassName?: string;
    width?: string | number;
    height?: string | number;
  }[];
}

const SkeletonLoaders: FC<Props> = ({ loaderList }) => {
  return (
    <>
      {loaderList.map((loader, index) => {
        return (
          <Skeleton
            key={index}
            containerClassName={loader.containerClassName || ''}
            className={cn(loader?.className)}
            width={loader?.width || '100%'}
            height={loader?.height || '100%'}
          />
        );
      })}
    </>
  );
};

export default SkeletonLoaders;
